// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notes-btn[data-v-7c1a41a4] {\n    border: none;\n    background: none;\n    color: inherit;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
